import { doc, getDoc, type Firestore } from 'firebase/firestore';
import type { Tenant } from '@kawai/shared';
import { db as defaultDb } from '../firebase.js';

/**
 * S-10: 単一テナント doc の取得（Layout のブランド表示用 / S-04 の tenant-portal 実装と同一）。
 *
 * Firestore Rules (T-04): `tenants/{tid}` は saas-admin または `tenantId() == tid`
 * のみ read 許可。tenant-fuel は claims.tenantId と一致する doc しか読まないので
 * permission-denied は発生しない想定。
 *
 * doc が存在しない場合は `null` を返す（ブランド表示はデフォルトにフォールバック）。
 */
export async function fetchTenantById(
  tenantId: string,
  db: Firestore = defaultDb,
): Promise<Tenant | null> {
  const ref = doc(db, 'tenants', tenantId);
  const snap = await getDoc(ref);
  if (!snap.exists()) return null;
  return { id: snap.id, ...(snap.data() as Omit<Tenant, 'id'>) };
}
